import axiosTokenInstance from 'services/api/backoffice';
import { DETAIL_LIST_GIFT_SIM_IPB, DETAIL_LIST_GIFT_SIM_IPB_ERROR } from '_models/redux/types';

// Action function
export const detailGiftSimIpbAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `/api/backoffice/orders/gifts/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_LIST_GIFT_SIM_IPB,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_LIST_GIFT_SIM_IPB_ERROR,
      response: e || {},
    });
  }
};
